/**
 * Production : aucun message dans la console du navigateur (ni log, ni avertissement, ni erreur).
 * Gardé en local (`yarn dev`) et en staging (REACT_APP_APP_ENV="staging") pour le débogage.
 * Importé en premier dans index.js, avant tout autre module.
 */
const isProductionBuild = process.env.NODE_ENV === 'production' && process.env.REACT_APP_APP_ENV !== 'staging';

if (isProductionBuild && typeof window !== 'undefined' && window.console) {
    const noop = () => {};
    ['log', 'info', 'debug', 'warn', 'error', 'trace', 'table', 'group', 'groupCollapsed', 'groupEnd', 'dir', 'time', 'timeEnd', 'count', 'assert']
        .forEach((method) => {
            if (typeof window.console[method] === 'function') window.console[method] = noop;
        });
}
